import { profilesApi } from '@/api';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useComplainProfileById = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: profilesApi.complainProfileById,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: t('your_complaint_has_been_received')
            });
        },
        onError: (error) => {
            console.error('Error complain profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: t('send_request_error')
            });
        },
    });

    return mutation;
};
